import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';
import React, { useState, useEffect, useRef } from 'react';
import apis from '../../api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';

const ApprovalFlow = () => {
    const [approverConf, setApproverConf] = useState([])
    const [approverConfDetail, setApproverConfDetail] = useState([])
    const [typeNoveltiesList, setTypeNoveltiesList] = useState([])
    const [typeApproverList, setTypeApproverList] = useState([])
    const [contractList, setContractList] = useState([])

    const [loadPage, setLoadPage] = useState(false);
    const [loading1, setLoading1] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)
    const [loading4, setLoading4] = useState(false)
    const [loading5, setLoading5] = useState(false)
    const [loading6, setLoading6] = useState(false)
    const [isOpenConf, setIsOpenConf] = useState(false)
    const [isOpenConfDetail, setIsOpenConfDetail] = useState(false)
    const [isOpenConfUpdate, setIsOpenConfUpdate] = useState(false)
    const [isOpenConfDetailUpdate, setIsOpenConfDetailUpdate] = useState(false)
    const [isOpenConfDelete, setIsOpenConfDelete] = useState(false)
    const [isOpenConfDetailDelete, setIsOpenConfDetailDelete] = useState(false)

    const headers = { Authorization: localStorage.getItem("token") }
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')

    const [confName, setConfName] = useState("")
    const [confGroup, setConfGroup] = useState("")
    const [confId, setConfId] = useState("")

    const [noveltyType, setNoveltyType] = useState("")
    const [approverType, setApproverType] = useState("")
    const [approverContract, setApproverContract] = useState("") 
    const [approverLevel, setApproverLevel] = useState("")
    const [confApproverId, setConfApproverId] = useState("")

    const toast = useRef(null);

    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(5);
    const [approverConfSelected, setApproverConfSelected] = useState(null);
    const [approverConfDetailSelected, setApproverConfDetailSelected] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [filters2, setFilters2] = useState(null);
    const [globalFilterValue2, setGlobalFilterValue2] = useState('');

    useEffect(() => {
        getConfList()
        getConf()
    }, [])

    const hideModalConf = () => {
        setConfName("")
        setConfGroup("")
        setConfId("")
        setIsOpenConf(false)
    }

    const hideModalConfUpdate = () => {
        setConfName("")
        setConfGroup("")
        setConfId("")
        setIsOpenConfUpdate(false)
    }

    const hideModalConfDelete = () => {
        setConfName("")
        setConfGroup("")
        setConfId("")
        setIsOpenConfDelete(false)
    }

    const hideModalConfDetail = () => {
        setNoveltyType("")
        setApproverType("")
        setApproverContract("")
        setConfApproverId("")
        setConfId("")
        setApproverLevel("")
        setIsOpenConfDetail(false)
    }

    const hideModalConfDetailUpdate = () => {
        setNoveltyType("")
        setApproverType("")
        setApproverContract("")
        setConfApproverId("")
        setConfId("")
        setApproverLevel("")
        setIsOpenConfDetailUpdate(false)
    }

    const hideModalConfDetailDelete = () => {
        setNoveltyType("")
        setApproverType("")
        setApproverContract("")
        setConfApproverId("")
        setConfId("")
        setApproverLevel("")
        setIsOpenConfDetailDelete(false)
    }

    //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    //Limpiar e inicializar los filtros
    const clearFilter1 = () => {
        initFilters1();
    }

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-plus" label="Agregar" className="p-button-success p-button-sm " onClick={() => setIsOpenConf(true)}/>
                <div className='flex flex-row gap-1'>
                    <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search"> </InputIcon>
                        <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
                    </IconField>
                </div>
            </div>
        )
    }

    //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
    const header1 = renderHeader1();

    //Limpiar filtros de la tabla
    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'JOB': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CONTRACT_TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'RETIREMENT_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    const onGlobalFilterChange2 = (e) => {
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;
        setFilters2(_filters1);
        setGlobalFilterValue2(value);
    }

    //Limpiar e inicializar los filtros
    const clearFilter2 = () => {
        initFilters2();
    }

    const renderHeader2 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-plus" label="Agregar" className="p-button-success p-button-sm " disabled={!approverConfSelected} onClick={() => {setConfId(approverConfSelected?.GROUP_ID); setIsOpenConfDetail(true)}}/>
                <div className='flex flex-row gap-1'>
                    <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter2} />
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search"> </InputIcon>
                        <InputText value={globalFilterValue2} onChange={onGlobalFilterChange2} placeholder="Palabra clave" className="p-inputtext-sm" />
                    </IconField>
                </div>
            </div>
        )
    }

    //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
    const header2 = renderHeader2();

    //Limpiar filtros de la tabla
    const initFilters2 = () => {
        setFilters2({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'JOB': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CONTRACT_TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'RETIREMENT_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    //Nombre de las opciciones para los filtros
    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];
    
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
            { label: 5, value: 5 },
            { label: 10, value: 10 },
            { label: 20, value: 20 }
            ];

            return (
            <React.Fragment>
                <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
                <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
            </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
            <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                {options.first} - {options.last} of {options.totalRecords}
            </span>
            )
        }
    };

    const getConfList = async () => {
        try{
            await apis.approverConfList(entity, client, headers).then(res => { 
                setTypeNoveltiesList(res.data.TYPE_NOVELTIES)
                setTypeApproverList(res.data.TYPE_APPROVER)
                setContractList(res.data.CONTRACTS)
            })
        }
        catch(error){
            console.log(error)
        }
    }

    const getConf = async (action = 'other') => {
        setLoadPage(false)
        try{
            await apis.getApproverConf(entity, client, headers).then(res => {
                const data = res.data.MASTER_GR_APROVER
                if(action !== "post")
                if(approverConfSelected){
                    const newSelected = data.filter(app => app.GROUP_ID === approverConfSelected.GROUP_ID)[0]
                    handleSelection(newSelected)
                }
                setApproverConf(data)
            })
        }
        catch(error){
            console.log(error)
        }
        finally{
            setLoadPage(true)
        }
    }

    const postConf = async () => {
        setLoading1(true)
        try{
            const payload = {
                ENTITY: entity,
                CLIENT: client,
                NAME: confName,
                COD_GROUP: confGroup,
            }
            await apis.postApproverConf(payload, headers).then(res => {
                setApproverConfSelected(null)
                setApproverConfDetail([])
                getConf("post")
                hideModalConf()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Grupo aprobador creado exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading1(false)
        }
    }

    const putConf = async () => {
        setLoading2(true)
        try{
            const payload = {
                ENTITY: entity,
                CLIENT: client,
                NAME: confName,
                COD_GROUP: confGroup,
                GROUP_ID: confId,
            }
            await apis.putApproverConf(payload, headers).then(res => {
                getConf()
                hideModalConfUpdate()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Grupo aprobador actualizado exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading2(false)
        }
    }

    const deleteConf = async () => {
        setLoading3(true)
        try{
            await apis.delApproverConf(entity, client, confId, headers).then(res => {
                getConf()
                hideModalConfDelete()
                toast.current.show({ severity: 'info', summary: 'Éxito', detail: "Grupo aprobador eliminado exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading3(false)
        }
    }

    const postConfDetail = async () => {
        setLoading4(true)
        try{
            const payload = {
                ENTITY: entity,
                CLIENT: client,
                GROUP_ID: confId,
                TYPE_NOVELTIES: noveltyType.detail_id,
                TYPE_APPROVER: approverType.detail_id,
                CONTRACT_ID: approverContract.CODE,
                LEVEL_APPROV: approverLevel

            }
            await apis.postApproverConfDetail(payload, headers).then(res => {
                getConf()
                hideModalConfDetail()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Aprobador configurado exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading4(false)
        }
    }

    const putConfDetail = async () => {
        setLoading5(true)
        try{
            const payload = {
                ENTITY: entity,
                CLIENT: client,
                GROUP_ID: confId,
                TYPE_NOVELTIES: noveltyType.detail_id,
                TYPE_APPROVER: approverType.detail_id,
                CONTRACT_ID: approverContract && approverContract.CODE,
                LEVEL_APPROV: approverLevel,
                GROUP_APPROV_ID: confApproverId
            }
            await apis.putApproverConfDetail(payload, headers).then(res => {
                getConf()
                hideModalConfDetailUpdate()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Aprobador actualizado exitosamente"});
            })
        }
        catch(err){
            console.log(err)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading5(false)
        }
    }

    const deleteConfDetail = async () => {
        setLoading6(true)
        try{
            await apis.delApproverConfDetail(entity, client, confApproverId, headers).then(res => {
                getConf()
                hideModalConfDetailDelete()
                toast.current.show({ severity: 'info', summary: 'Éxito', detail: "Grupo aprobador eliminado exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading6(false)
        }
    }

    const setConfData = (rowData) => {
        setConfName(rowData.NAME)
        setConfId(rowData.GROUP_ID)
        setConfGroup(rowData.COD_GROUP)
        setIsOpenConfUpdate(true)
    }
    
    const setConfDetailData = (rowData) => {
        const type = typeNoveltiesList.filter(nov => nov.detail_id === rowData.APPROVAL_NOVELTY)[0]
        const approver = typeApproverList.filter(app => app.detail_id === rowData.APPROVAL_TYPE)[0]
        const contract = contractList.filter(con => con.CODE === rowData.CONTRACT_ID)[0]
        setNoveltyType(type)
        setApproverType(approver)
        setApproverContract(contract)
        setConfId(rowData.GROUP_ID)
        setConfApproverId(rowData.GROUP_APPROV_ID)
        setApproverLevel(rowData.LEVEL_APPROV)
        setIsOpenConfDetailUpdate(true)
    } 

    const actionBodyTemplate = (rowData) => {
        return (
            <div className='flex flex-row gap-1'>
                <Button icon="pi pi-pencil" className="p-button-warning p-button-sm text-xs" onClick={() => setConfData(rowData)}/>
                <Button icon="pi pi-trash" className="p-button-danger p-button-sm text-xs" onClick={() => {setConfId(rowData.GROUP_ID); setIsOpenConfDelete(true)}}/>
            </div>
        )
    }

    const actionBodyDetailTemplate = (rowData) => {
        return (
            <div className='flex flex-row gap-1'>
                <Button icon="pi pi-pencil" className="p-button-warning p-button-sm text-xs" onClick={() => setConfDetailData(rowData)}/>
                <Button icon="pi pi-trash" className="p-button-danger p-button-sm text-xs" onClick={() => {setConfApproverId(rowData.GROUP_APPROV_ID); setIsOpenConfDetailDelete(true)}}/>
            </div>
        )
    }

    const handleSelection = (value) => {
        console.log(value)
        setApproverConfSelected(value)
        setConfId(value?.GROUP_ID)
        let newData = []
        value?.DETAIL_GR_APROVER.forEach(element => {
            let approvalNovelty = element.APPROVAL_NOVELTY.split('|')
            let approvalType = element.APPROVAL_TYPE.split('|')
            let newElement = {
                ...element,
                APPROVAL_NOVELTY: approvalNovelty[0],
                APPROVAL_TYPE: approvalType[0],
                APPROVAL_NOVELTY_DESC: approvalNovelty[1],
                APPROVAL_TYPE_DESC: approvalType[1],
                GROUP_NAME: value.NAME
            }
            newData.push(newElement)
        });
        setApproverConfDetail(newData)
    } 

    const addConfFooter = (
        <div>
            <Button onClick={() => { setLoading1(false); hideModalConf() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading1} onClick={() => postConf()} disabled={!confName || !confGroup}/>
        </div>
    );

    const addConfHeader = (
        <div>
            <h3>Configurar grupo aprobadores</h3>
        </div>
    )

    const updateConfFooter = (
        <div>
            <Button onClick={() => { setLoading2(false); hideModalConfUpdate() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading2} onClick={() => putConf()} disabled={!confName || !confGroup}/>
        </div>
    );

    const updateConfHeader = (
        <div>
            <h3>Editar grupo aprobadores</h3>
        </div>
    )

    const deleteConfFooter = (
        <div>
            <Button onClick={() => { setLoading3(false); hideModalConfDelete() }}>Cancelar</Button>
            <Button className='p-button-danger' label="Eliminar" loading={loading3} onClick={() => deleteConf()} />
        </div>
    );

    const deleteConfHeader = (
        <div>
            <h3>¿Desea eliminar el grupo de aprobadores?</h3>
        </div>
    )

    const addConfDetailFooter = (
        <div>
            <Button onClick={() => { setLoading4(false); hideModalConfDetail() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading4} onClick={() => postConfDetail()} disabled={ !approverType || !approverLevel || !noveltyType}/>
        </div>
    );

    const addConfDetailHeader = (
        <div>
            <h3>Agregar aprobador</h3>
        </div>
    )

    const updateConfDetailFooter = (
        <div>
            <Button onClick={() => { setLoading5(false); hideModalConfDetailUpdate() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading5} onClick={() => putConfDetail()} disabled={ !approverType || !approverLevel || !noveltyType}/>
        </div>
    );

    const updateConfDetailHeader = (
        <div>
            <h3>Editar aprobador</h3>
        </div>
    )

    const deleteConfDetailFooter = (
        <div>
            <Button onClick={() => { setLoading6(false); hideModalConfDetailDelete() }}>Cancelar</Button>
            <Button className="p-button-danger" label="Eliminar" loading={loading6} onClick={() => deleteConfDetail()} />
        </div>
    );

    const deleteConfDetailHeader = (
        <div>
            <h3>¿Desea eliminar el aprobador?</h3>
        </div>
    )

    const msgContent = (
        <div>
            <a style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#3b82f6' }}>
            {process.env.REACT_APP_DISABLE_MSG}
            </a>
        </div>
    )

    return(
        <div className="flex flex-wrap align-items-center justify-content-center flex-column align-self-center">
            <Tooltip target=".info" className='indigo-tooltip ml-1' />
            <Toast ref={toast} style={{ backgroundColor: 'white' }} />
            <Dialog header={addConfHeader} footer={addConfFooter} visible={isOpenConf}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalConf}>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Nombre grupo</label>
                    <InputText value={confName} onChange={(e) => setConfName(e.target.value)} placeholder="Nombre grupo" className="p-inputtext-sm" />
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Código de grupo</label>
                    <InputText value={confGroup} onChange={(e) => setConfGroup(e.target.value)} placeholder="Código de grupo" className="p-inputtext-sm" />
                </div>
            </Dialog>
            <Dialog header={updateConfHeader} footer={updateConfFooter} visible={isOpenConfUpdate}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalConfUpdate}>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">ID grupo</label>
                    <InputText value={confId} placeholder="Nombre grupo" className="p-inputtext-sm" disabled={true}/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Nombre grupo</label>
                    <InputText value={confName} onChange={(e) => setConfName(e.target.value)} placeholder="Nombre grupo" className="p-inputtext-sm" />
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Código de grupo</label>
                    <InputText value={confGroup} onChange={(e) => setConfGroup(e.target.value)} placeholder="Código de grupo" className="p-inputtext-sm" />
                </div>
            </Dialog>
            <Dialog header={deleteConfHeader} footer={deleteConfFooter} visible={isOpenConfDelete}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalConfDelete}>
            </Dialog>
            <Dialog header={addConfDetailHeader} footer={addConfDetailFooter} visible={isOpenConfDetail}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalConfDetail}>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Tipo novedad</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Tipo novedad" value={noveltyType} options={typeNoveltiesList} onChange={(e) => setNoveltyType(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Tipo aprobador</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Tipo aprobador" value={approverType} options={typeApproverList} onChange={(e) => setApproverType(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Contrato aprobador</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='NAME' placeholder="Contrato aprobador" disabled={approverType.code === 'BOSS'} value={approverContract} options={contractList} onChange={(e) => setApproverContract(e.value)} />
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Nivel de aprobador</label>
                    <InputText value={approverLevel} onChange={(e) => setApproverLevel(e.target.value)} placeholder="Nivel de aprobador" className="p-inputtext-sm" type='number'/>
                </div>
            </Dialog>
            <Dialog header={updateConfDetailHeader} footer={updateConfDetailFooter} visible={isOpenConfDetailUpdate}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalConfDetailUpdate}>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">ID aprobador</label>
                    <InputText value={confApproverId} placeholder="ID aprobador" className="p-inputtext-sm" type='number' disabled={true}/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Tipo novedad</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Tipo novedad" value={noveltyType} options={typeNoveltiesList} onChange={(e) => setNoveltyType(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Tipo aprobador</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Tipo aprobador" value={approverType} options={typeApproverList} onChange={(e) => setApproverType(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Contrato aprobador</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='NAME' placeholder="Contrato aprobador" disabled={approverType.code === 'BOSS'} value={approverContract} options={contractList} onChange={(e) => setApproverContract(e.value)} />
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Nivel de aprobador</label>
                    <InputText value={approverLevel} onChange={(e) => setApproverLevel(e.target.value)} placeholder="Nivel de aprobador" className="p-inputtext-sm" type='number'/>
                </div>
            </Dialog>
            <Dialog header={deleteConfDetailHeader} footer={deleteConfDetailFooter} visible={isOpenConfDetailDelete}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalConfDetailDelete}>
            </Dialog>
            <div className="flex flex-column align-items-center justify-content-center font-bold text-4xl mt-5">
                <span className="text-900">Flujo Aprobación Solicitudes</span>
            </div>
            {localStorage.getItem('tracking') === 'N' && localStorage.getItem('novelties') === 'N' ?
                <div className='flex justify-content-center'>
                    <Card style={{ width: "60%" }}>
                        <Message severity="info"
                        style={{
                            width: "100%",
                            fontSize: "18px",
                            border: 'solid #696cff',
                            borderWidth: '2px',
                            color: '#696cff'
                        }}
                        content={msgContent}
                        />
                    </Card>
                </div>
                :
                <SkeletonTable load={loadPage} width='90%'>
                    <Toolbar className='card flex flex-row justify-content-start bg-white w-9 mt-2' start={<span className='font-bold'>Manejo grupo aprobadores</span>} end={<div></div>}
                        style={{ background: 'linear-gradient(90deg, rgba(16, 97, 162, 1) 0%, rgba(2, 150, 207, 1) 100%)', color: 'white' }}
                    />
                    <DataTable className="card text-xs w-9" value={approverConf} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                        selection={approverConfSelected} onSelectionChange={(e) => handleSelection(e.value)} dataKey="GROUP_ID" selectionMode={"single"}
                        size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['GROUP_ID', 'NAME', 'COD_GROUP']}
                        header={header1} >
                        <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                        <Column field="GROUP_ID" header="ID" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por ID" sortable></Column>
                        <Column field="NAME" header="Nombre" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
                        <Column field="COD_GROUP" header="Código de grupo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Código de grupo" sortable></Column>
                        <Column header="Acciones" headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
                    </DataTable>
                    <Toolbar className='card flex flex-row justify-content-start bg-white w-9 mt-1' start={<span className='font-bold'>Configuración de aprobadores</span>}
                        style={{ background: 'linear-gradient(90deg, rgba(16, 97, 162, 1) 0%, rgba(2, 150, 207, 1) 100%)', color: 'white' }}
                    />
                    <DataTable className="card text-xs w-9" value={approverConfDetail} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                        selection={approverConfDetailSelected} onSelectionChange={(e) => setApproverConfDetailSelected(e.value)} dataKey="GROUP_APPROV_ID" selectionMode={"single"}
                        size="small" filters={filters2} filterDisplay="menu" globalFilterFields={['GROUP_APPROV_ID', 'APPROVAL_NOVELTY_DESC', 'APPROVAL_TYPE_DESC', 'CONTRACT_ID', 'NAME_CONTRACT', 'LEVEL_APPROV', 'GROUP_NAME']}
                        header={header2} >
                        <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                        <Column field="GROUP_APPROV_ID" header="ID" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por ID" sortable></Column>
                        <Column field="APPROVAL_NOVELTY_DESC" header="Tipo novedad" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tipo novedad" sortable></Column>
                        <Column field="APPROVAL_TYPE_DESC" header="Tipo aprobador" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tipo aprobador" sortable></Column>
                        <Column field="CONTRACT_ID" header="Contrato aprobador" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato aprobador" sortable></Column>
                        <Column field="NAME_CONTRACT" header="Nombre aprobador" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por nombre aprobador" sortable></Column>
                        <Column field="GROUP_NAME" header="Grupo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por grupo" sortable></Column>
                        <Column field="LEVEL_APPROV" header="Nivel aprobador" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por nivel aprobador" sortable></Column>
                        <Column headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyDetailTemplate} />
                    </DataTable>
                </SkeletonTable>}
        </div>
    )
}

export default ApprovalFlow
